
  import * as storyblokRuntime$_16BLRXcFY_45EcC_45Lc48eVurG3jEdveXMjfTw_fJdR5d4 from '/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.8.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$C_45dF23GyoKZ2LLmzVeA3jt3k3MRAIBM5uc8v7BGE0cw from '/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.8.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$_16BLRXcFY_45EcC_45Lc48eVurG3jEdveXMjfTw_fJdR5d4, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$C_45dF23GyoKZ2LLmzVeA3jt3k3MRAIBM5uc8v7BGE0cw, defaults: {} }
    }
  }
